import { useState } from 'react';
import { MappedAEMProperties } from '../../../../types';
import Layout from '../../../common/Layout/Layout';
import { ContentBlock } from '../../../../lib/types/aemDataModels';
import PureHeading from '../../../common/Heading/PureHeading';
import { HeadingLevel } from '../../../../lib/utils/HeadingMapper';
import Tile from '../../base/Tile/Tile';
import styles from './TileGrid.module.scss';
import Button from '../../../common/Button/Button';
import { useDevice } from '../../../../lib/hooks/device';
import { CY_TILE_GRID } from '../../../../lib/constants/cypress';

export type TileGridProps = {
  heading?: string;
  tiles?: ContentBlock[];
  showAllButtonLabel?: string;
} & MappedAEMProperties;

export const VISIBLE_GRID_TILES = {
  DEFAULT: {
    DESKTOP: 8,
    MOBILE: 6,
  },
  MAX: {
    MOBILE: 10,
  },
} as const;

const TileGrid = ({ heading, tiles, showAllButtonLabel }: TileGridProps) => {
  const [showAll, setShowAll] = useState(false);
  const device = useDevice();

  const visibleTiles = (() => {
    if (showAll) {
      return device === 'desktop' ? tiles?.length : VISIBLE_GRID_TILES.MAX.MOBILE;
    }

    if (device === 'mobile') {
      return VISIBLE_GRID_TILES.DEFAULT.MOBILE;
    }

    return VISIBLE_GRID_TILES.DEFAULT.DESKTOP;
  })();

  return (
    <Layout className={styles.wrapper} data-cy={CY_TILE_GRID}>
      {!!heading && (
        <PureHeading level={HeadingLevel.h2} as={HeadingLevel.h3} className={styles.heading}>
          {heading}
        </PureHeading>
      )}
      <ul className={styles.grid}>
        {tiles?.slice(0, visibleTiles).map(({ contentFragmentType, ...tileProps }) => (
          <Tile key={tileProps.uniqueId} {...tileProps} />
        ))}
      </ul>
      {!showAll && !!tiles && tiles.length > 8 && (
        <Button className={styles.showAllButton} variant="outlined" onClick={() => setShowAll(true)}>
          {showAllButtonLabel}
        </Button>
      )}
    </Layout>
  );
};

export default TileGrid;
